import { createFileRoute } from "@tanstack/react-router";
import { EsLegalPage, EsLegalSection } from "@/components/site/EsPage";
import { buildHead } from "@/lib/seo-head";

export const Route = createFileRoute("/es/legal/accesibilidad")({
  head: () =>
    buildHead({
      title: "Accesibilidad — Simply Approved Mortgages",
      description:
        "Compromiso de accesibilidad digital. Si tiene dificultades para usar este sitio, contáctenos.",
      url: "/es/legal/accesibilidad",
      locale: "es",
      breadcrumbs: [
        { name: "Inicio", url: "/es" },
        { name: "Accesibilidad", url: "/es/legal/accesibilidad" },
      ],
    }),
  component: Page,
});

function Page() {
  return (
    <EsLegalPage
      title="Accesibilidad"
      intro="Nos esforzamos por hacer que este sitio sea usable para todas las personas. Si encuentra barreras, queremos saberlo."
      enPath="/legal/accessibility"
      enLabel="Accessibility"
    >
      <EsLegalSection heading="Nuestro compromiso">
        <p>
          Seguimos las Pautas de Accesibilidad al Contenido Web (WCAG) 2.1 nivel AA como referencia y
          revisamos periódicamente la navegación por teclado, el contraste de color, las etiquetas de
          formularios y la estructura de encabezados.
        </p>
      </EsLegalSection>

      <EsLegalSection heading="¿Necesita ayuda?">
        <p>
          Si tiene dificultad para acceder a alguna parte del sitio o para completar un formulario,
          llámenos al{" "}
          <a href="tel:+18778137219" className="font-semibold text-brand hover:underline">
            877-813-7219
          </a>{" "}
          o envíenos un mensaje desde la página de contacto. Haremos nuestro mejor esfuerzo para
          proporcionarle la información de que necesita en el formato que le resulte más útil.
        </p>
      </EsLegalSection>
    </EsLegalPage>
  );
}
